import Vue from 'vue'
import Router from 'vue-router'
import localforage from 'localforage'

// components
import site from '@/components/site/routes'
import admin from '@/components/admin/routes'
import vp from '@/components/vp/routes'

// features
import auth from '@app/auth/routes'
import register from '@app/register/routes'
import forgotPassword from '@app/forgotPassword/routes'
import transacoes from '@app/admin/transacoes/routes'
import comprarFichasIndex from '@app/admin/comprarFichas/routes'

import store from '@/store'

const routes = [
  ...site,
  ...admin,
  ...vp,
  ...auth,
  ...register,
  ...forgotPassword,
  ...transacoes,
  ...comprarFichasIndex
]

Router.prototype.open = function (routeObject) {
  const {href} = this.resolve(routeObject)
  window.open(href, '_blank')
}

Vue.use(Router)
// Vue.use(VueSocketIO)

const isAutenticado = async (to, from, next) => {
 
    const token = await localforage.getItem('token')
    const vpUser = await localforage.getItem('vpUser')
    const user = await localforage.getItem('user')
 
    if (token && vpUser) {

      store.dispatch('setToken', {token})
      store.dispatch('auth/setUsuarioStorage', user)
    }
    
  }

const router = new Router({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  isAutenticado(to, from, next)
  if (from.name !== 'transacao.index' || to.name !== 'admin.dashboard') {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js